import { render, staticRenderFns } from "./TeacherProfileHeader.vue?vue&type=template&id=58db3b3c"
import script from "./TeacherProfileHeader.vue?vue&type=script&lang=js"
export * from "./TeacherProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports